import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { Message } from 'src/app/shared/models/message';
import { User } from 'src/app/shared/models/security/user';

@Component({
	selector: 'app-user-conversation',
	templateUrl: './user-conversation.component.html',
	styleUrls: ['./user-conversation.component.scss']
})
export class UserConversationComponent {
	@Input() userReceiver: User;
	@Input() messages: Message[] = [];
	@Input() currentUser: User;

	@ViewChild('scrolleur') scrolleurElement: ElementRef;
	
	constructor() {}

	precedentDate(message: Message, messages: Message[]): boolean {
		if (messages.indexOf(message) === 0) {
			return false;
		} else if (
			messages[messages.indexOf(message) - 1].createdAt
				.toString()
				.slice(0, 10) === message.createdAt.toString().slice(0, 10)
		) {
			return true;
		} else {
			return false;
		}
	}

	isToday(date: Date): boolean {
		const today = new Date(Date.now()).toISOString();
		return date.toString().slice(0, 10) === today.toString().slice(0, 10);
	}

	trackMessages(index: number, item: Message) {
		return index;
	}

	isFromCurrentUser(message) {
		return (
			message.idSender === this.userReceiver.id &&
			message.idReceiver === this.currentUser.id
		);
	}

	scrollToBottom(): void {
		try {
			this.scrolleurElement.nativeElement.scroll({
				top: this.scrolleurElement.nativeElement.scrollHeight,
				left: 0,
				behavior: 'smooth'
			});
			// this.scrolleurElement.nativeElement.scrollTop = this.scrolleurElement.nativeElement.scrollHeight;
		} catch (err) {}
	}
}
